import { DefaultTheme } from '../themes/themes/defaultTheme';
import ITheme from '../interfaces/iTheme';
import { SimpleTheme } from '../themes/themes/simpleTheme';
import { HalloweenTheme } from '../themes/themes/halloweenTheme';
import { LightTheme } from '../themes/themes/lightTheme';
import { DarkTheme } from '../themes/themes/darkTheme';
import { CircuitTheme } from '../themes/themes/circuit';
import { ComicBookTheme } from '../themes/themes/comicBookTheme'
import { CyberIconsTheme } from '../themes/themes/cyberIcons';
import { WinterTheme } from '../themes/themes/winterTheme';
import { CrosslandTheme } from '../themes/themes/crosslandTheme';
import { defineStore } from 'pinia';
import { LoveBytesTheme } from '../themes/themes/loveBytesTheme';
import { useThemeStore as useCrThemeStore } from '@cyber-range/cyber-range-lib-ui'

export const useThemeStore = defineStore('themeStore', {
    state: () =>
    ({
        showThemeEditor: false,
        availableThemes: [
            new DarkTheme(),
            new DefaultTheme(),
            new HalloweenTheme(),
            new LightTheme(),
            new SimpleTheme(),
            new CircuitTheme(),
            new ComicBookTheme(),
            new CyberIconsTheme(),
            new WinterTheme(),
            new CrosslandTheme(),
            new LoveBytesTheme(),
        ] as ITheme[],
        currentTheme: {isDark:false} as ITheme
    }),
    getters:
    {
        getCurrentTheme: (state) => state.currentTheme,

        isDark: (state) => !!state.currentTheme?.isDark,

        isLight: (state) => !state.currentTheme?.isDark,

    },
    actions:
    {
        setCurrentTheme(themeId:string): void
        {
            this.currentTheme = this.availableThemes.find(t => t.id === themeId) || this.availableThemes[0];
            useCrThemeStore().theme.colors = this.currentTheme.colors;
        },
        resetCurrentTheme(): void
        {
            this.currentTheme = this.availableThemes[0];
        },
    }
});
